import { gql } from "@apollo/client";

export const visionBoardDetail = gql`
  query visionBoard(
    $id: ID!
    $companyId: ID!
    $visionType: VisionListType
    $visionBoardPrimaryFilter: VisionStatus
    $visionBoardSecondaryFilter: [VisionTags]
    $visionSortOption: VisionSortOption
    $limit: Int
    $userId: ID
    $nextToken: String
    $myVisions: Boolean
  ) {
    getUser(id: $id, userCompanyId: $companyId) {
      firstName
      id
      lastName
      listVisionCustom(
        visionListType: $visionType
        userId: $userId
        visionBoardPrimaryFilter: $visionBoardPrimaryFilter
        visionBoardSecondaryFilter: $visionBoardSecondaryFilter
        visionSortOption: $visionSortOption
        nextToken: $nextToken
        limit: $limit
        myVisions: $myVisions
      ) {
        nextToken
        totalVisionCount
        remainingVisionCount
        items {
          totalComments
          id
          title
          generateSharableLink
          createdByUserId
          description
          enableComments
          endDate
          isCompanyVision
          startDate
          isNew
          requireEndDate
          visionTagKey
          optedoutOfNotification
          logo {
            fileName
            key
            url
          }
          encouragementWords {
            items {
              id
              createdByUserId
              createdBy {
                lastName
                firstName
                profileImage {
                  url
                  fileName
                }
              }
              encouragementWord
              createdAt
            }
          }
          comments {
            items {
              id
              comment
              createdByUserId
              createdBy {
                lastName
                firstName
                profileImage {
                  url
                  fileName
                }
              }
              createdAt
            }
          }
          linkTarget {
            id
            title
            logo {
              url
              fileName
            }
            createdByUserId
            createdBy {
              firstName
              fullName
              lastName
              id
              profileImage {
                url
                fileName
              }
            }
          }
          visibilityOption
          visionCompanyId
          visionStatus
          reportedVision {
            id
            reportedReason
            reportingComment
            reportedByUser {
              firstName
              lastName
              userid
              profileImage {
                fileName
              }
            }
          }
          visionUsers {
            items {
              id
              userId
            }
          }
          createdBy {
            id
            firstName
            lastName
            profileImage {
              url
              fileName
            }
          }
        }
      }
      profileImage {
        url
        fileName
      }
    }
  }
`;

export const getPublicVision = gql`
  query getVision($id: ID!) {
    getPublicVision(id: $id) {
      id
      title
      description
      enableComments
      endDate
      isCompanyVision
      startDate
      isNew
      requireEndDate
      visionTagKey
      logo {
        fileName
        url
      }
      encouragementWords {
        items {
          id
          encouragementWord
          visionId
        }
      }
      comments {
        items {
          comment
          id
          visionId
        }
      }
      visibilityOption
      visionCompanyId
      visionStatus
      createdByUser {
        firstName
        lastName
        profileImage {
          url
          fileName
        }
      }
      createdByUserId
    }
  }
`;

/**
 * get word cloud
 */

export const getWordCloud = gql`
  query getWordCloud($id: ID!) {
    getCompany(id: $id) {
      name
      wordCloud {
        word

        count
      }
    }
  }
`;
